export default __webpack_public_path__ + "static/media/mypay-dark.ed47d7bd.png";